import { useMutation, useQueryClient } from '@tanstack/react-query';
import type AgentApiProvidedJobPostsShow from '@/types/serializers/AgentApiProvidedJobPostsShow';

export default function useArchiveProvidedJobPost() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}/archive`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'アーカイブに失敗しました');
      }

      const result: AgentApiProvidedJobPostsShow = await response.json();
      return result;
    },
    onSuccess: (data, variables) => {
      // キャッシュを更新
      queryClient.setQueryData(['providedJobPost', variables.id], data);
      queryClient.invalidateQueries({ queryKey: ['providedJobPost', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['providedJobPosts'] });
    },
  });
}
